const routePath = {
  prefixAuthed: '/s',
  root: '/',
  advertiser: 'advertiser',
  adsales: 'adsales',
  collectionBills: 'col-bills',
  collection: 'collection',
  collectionPaid: 'col-paid',
  dashboard: 'dashboard',
  collectionInvoices: 'col-invoices',
  resetPassword: 'reset-password',
  scheduleAD: 'scheduleAD/:scheduleType/:adType',
  subscriber: 'subscriber',
  subscriberNote: 'subscriberNote',
  otherRevenue: 'otherRevenue',
  report: 'report'
}

export default routePath;
